// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input-symbol":"LAAxL","price-input-wrapper":"U8-UV","dollar":"N0ec7","percentage":"Mlewn","custom-rangeBtn":"cR7nr"};